// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Current version of the `@azure/ai-projects` package.
 */
export const SDK_VERSION = `2.0.2`;

/**
 * The package name of the `@azure/ai-projects` package.
 */
export const PACKAGE_NAME = "@azure/ai-projects";
